module.exports = __webpack_public_path__ + "img/github.0267e26b.svg";